import { DataGridItem } from '../../../core/component'

export enum ShippingMethodKind {
  Delivery = 'Delivery',
  StorePickup = 'StorePickup',
  Fallback = 'Fallback',
}

export enum ShippingRuleEffect {
  Include = 'Include',
  Exclude = 'Exclude',
}

export const SHIPPING_RULE_EFFECT_COLOR: Record<ShippingRuleEffect, string> = {
  [ShippingRuleEffect.Include]: 'blue',
  [ShippingRuleEffect.Exclude]: 'red',
}

export interface ShippingMethodRule {
  id: number
  shippingMethodId: number
  label: string | null
  effect: ShippingRuleEffect
  countryCode: string | null
  state: string | null
  minCartValue: number | null
  maxCartValue: number | null
  priceOverride: number | null
  sortOrder: number
  isActive: boolean
}

export enum ShippingFallbackReason {
  NoEligibleMethod = 'NoEligibleMethod',
  NotConfigured = 'NotConfigured',
  EvaluationError = 'EvaluationError',
}

export interface ShippingMethod {
  id: number
  key: string
  title: string
  description: string | null
  checkoutNoticeTitle: string | null
  checkoutNotice: string | null
  kind: ShippingMethodKind
  basePrice: number
  sortOrder: number
  isActive: boolean
  isSystem: boolean
  deletedAt: string | null
  rules: ShippingMethodRule[]
}

export interface ShippingMethodEntry extends DataGridItem {
  method: ShippingMethod
}

export interface ShippingMethodInput {
  key: string
  title: string
  description?: string | null
  checkoutNoticeTitle?: string | null
  checkoutNotice?: string | null
  kind?: ShippingMethodKind
  basePrice?: number
  isActive?: boolean
}

export interface ShippingMethodRuleInput {
  label?: string | null
  effect?: ShippingRuleEffect
  countryCode?: string | null
  state?: string | null
  minCartValue?: number | null
  maxCartValue?: number | null
  priceOverride?: number | null
  sortOrder?: number
  isActive?: boolean
}

export interface ShippingRuleDraft extends ShippingMethodRuleInput {
  draftKey: string
}

export interface ShippingCountry {
  code: string
  name: string
}

export interface ShippingState {
  id: number
  key: string
  name: string
}

export interface EligibleShippingMethod {
  id: number
  key: string
  title: string
  description: string | null
  checkoutNoticeTitle: string | null
  checkoutNotice: string | null
  kind: ShippingMethodKind
  price: number
  sortOrder: number
  matchedRuleId: number | null
  matchedRuleLabel: string | null
  fallbackApplied: boolean
  fallbackReason: ShippingFallbackReason | null
}

/** Only the expected reason is benign; the other two mean an administrator needs to act. */
export const SHIPPING_FALLBACK_REASON_COLOR: Record<ShippingFallbackReason, string> = {
  [ShippingFallbackReason.NoEligibleMethod]: 'orange',
  [ShippingFallbackReason.NotConfigured]: 'red',
  [ShippingFallbackReason.EvaluationError]: 'red',
}

export interface ShippingEvaluationInput {
  country?: string | null
  state?: string | null
  cartSubtotal: number
  includePickup?: boolean
}

export const SHIPPING_METHOD_KIND_LABEL: Record<ShippingMethodKind, string> = {
  [ShippingMethodKind.Delivery]: 'Delivery',
  [ShippingMethodKind.StorePickup]: 'Store Pickup',
  [ShippingMethodKind.Fallback]: 'Fallback',
}

export const SHIPPING_METHOD_KIND_COLOR: Record<ShippingMethodKind, string> = {
  [ShippingMethodKind.Delivery]: 'blue',
  [ShippingMethodKind.StorePickup]: 'green',
  [ShippingMethodKind.Fallback]: 'orange',
}

export const UNITED_STATES_CODE = 'US'
